module.exports = __webpack_public_path__ + "static/img/14.b0a99dd5.jpg";